
import { LEDGER_TYPE_CODE } from "./LedgerTypeCode";
import { LEDGER_TYPE_GROUP } from "./LedgerTypeGroup.jsx";
import { LEDGER_TYPE_GROUP_NAME } from "./LedgerTypeGroupe";
import { LEDGER_TYPE_NAME } from "./LedgeTypeName";
import { SEARCH_OPTION } from "./SearchOption.jsx";
import { VOUCHER_ACTIONS } from "./VocuherActions";
import { VOUCHER_TYPE } from "./VocuhertType";

export const  DROPDOWN_OPTION = {

    PAID_STATUS : [
     { name: 'ALL INVOICE', code: 0 },
     { name: 'CREDIT INVOICE', code: 1 },
     { name: 'PARTIAL PAID', code: 2 },
     { name: 'FULLY PAID', code: 3 },
     {name:'UNSETTLED INVOICE' , code:5}
   ],

   TOTAL_BY:[
    {name:'TOTAL BY COST PRICE', code:0},
    {name:'TOTAL BY RETAIL PRICE', code :1}

   ],

   SEARCH_BY:[
    {name:'Barcode', code:SEARCH_OPTION.BARCODE},
    {name:"Name",code: SEARCH_OPTION.NAME},
    {name:"Description", code:SEARCH_OPTION.DESCRIPTION},
    // {name:"Category",code:SEARCH_OPTION.CATEGORY},
    // {name:"Brande", code:SEARCH_OPTION.BARND},
   ],

   
    CASH_BOOK :0,
    BANK :  1,
    CREDIT_CARD : 2,

  
   LEDGER_TYPE_SHOP :[
   {name:LEDGER_TYPE_NAME.CASH_BOOK_SH, code:LEDGER_TYPE_CODE.CASH_BOOK_SH}, 
   {name:LEDGER_TYPE_NAME.CA_P_AND_P_SH, code:LEDGER_TYPE_CODE.CA_P_AND_P_SH} ,
   {name:LEDGER_TYPE_NAME.SEYLAN_BANK_SH, code:LEDGER_TYPE_CODE.SEYLAN_BANK_SH},
   {name:LEDGER_TYPE_NAME.DFCC_SH, code:LEDGER_TYPE_CODE.DFCC_SH},
   {name:LEDGER_TYPE_NAME.HNB_SH, code:LEDGER_TYPE_CODE.HNB_SH},
   {name:LEDGER_TYPE_NAME.CC_DFCC_SH, code:LEDGER_TYPE_CODE.CC_DFCC_SH},
   {name:LEDGER_TYPE_NAME.CC_HNB_SH, code:LEDGER_TYPE_CODE.CC_HNB_SH},
   {name:LEDGER_TYPE_NAME.LOCKER, code:LEDGER_TYPE_CODE.LOCKER},

   ],

      LEDGER_TYPE_STORE :[
      {name:LEDGER_TYPE_NAME.CASH_BOOK_ST,   code: LEDGER_TYPE_CODE.CASH_BOOK_ST},
      {name:LEDGER_TYPE_NAME.CA_P_AND_P_ST,  code: LEDGER_TYPE_CODE.CA_P_AND_P_ST},
      {name:LEDGER_TYPE_NAME.CA_FAZIL,       code: LEDGER_TYPE_CODE.CA_FAZIL},
      {name:LEDGER_TYPE_NAME.CA_FAHIK,       code: LEDGER_TYPE_CODE.CA_FAHIK},
      {name:LEDGER_TYPE_NAME.CA_FAHJI,       code: LEDGER_TYPE_CODE.CA_FAHJI},
      {name:LEDGER_TYPE_NAME.SEYLAN_BANK_ST, code: LEDGER_TYPE_CODE.SEYLAN_BANK_ST},
      {name:LEDGER_TYPE_NAME.DFCC_ST,        code: LEDGER_TYPE_CODE.DFCC_ST},
      {name:LEDGER_TYPE_NAME.HNB_ST,         code: LEDGER_TYPE_CODE.HNB_ST},
      {name:LEDGER_TYPE_NAME.FAZIL_LOAN,     code: LEDGER_TYPE_CODE.FAZIL_LOAN},
      {name:LEDGER_TYPE_NAME.FAHIK_LOAN,     code: LEDGER_TYPE_CODE.FAHIK_LOAN},
      {name:LEDGER_TYPE_NAME.FAHJI_LOAN,     code: LEDGER_TYPE_CODE.FAHJI_LOAN},
   ],

   VOUCHER_ACTIONS:[
      {name: "Vocuher Issued" ,   code:VOUCHER_ACTIONS.ISSUED },
      {name: "Vocuher Not Issued" ,   code:VOUCHER_ACTIONS.NOT_ISSUED},
      {name: "Vocuher Invoiced",   code: VOUCHER_ACTIONS.INVOICED },
   ],

      VOUCHER_TYPE:[
      {name: "Free Vocuher" ,   code: VOUCHER_TYPE.FREE_VOUCHER },
      {name: "Paid Vocuher" ,   code: VOUCHER_TYPE.PAID_VOUCHER},
   ],

    TRANSACTION_MODE : [
       { name: 'CASH', code: 0 },
       { name: 'CHEQUE', code: 1 },
     ],

   LEDGER_TYPE_GROUP :[
      {name:LEDGER_TYPE_GROUP_NAME.BANK,  code: LEDGER_TYPE_GROUP.BANK},
      {name:LEDGER_TYPE_GROUP_NAME.CREDIT_CARD,       code:LEDGER_TYPE_GROUP.CREDIT_CARD},
      {name:LEDGER_TYPE_GROUP_NAME.CAPITAL_ACCOUNT,       code: LEDGER_TYPE_GROUP.CAPITAL_ACCOUNT},
      {name:LEDGER_TYPE_GROUP_NAME.CASH_CONTROLLER,       code: LEDGER_TYPE_GROUP.CASH_CONTROLLER},
   ],
   

   
}
